import ContentSubjectIcon from "web/src/content-subjects/components/ContentSubjectIcon"
import getContentSubjectColor from "web/src/content-subjects/getContentSubjectColor"
import { Title, TitleWrapper } from "./LessonListItem"
import { ContentSubjectType } from "db/enums"
import styled from "@emotion/styled"
import { ContentSubjectOrder } from "app/content-subjects/consts"

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`

type Props = {
  title: string
} & (
    | {
      contentSubject: ContentSubjectType
      contentSubjects?: never
    }
    | {
      contentSubject?: never
      contentSubjects: ContentSubjectType[]
    }
  )

type ContentSubjectContainerType = {
  contentSubjects: ContentSubjectType[]
}

export const ContentSubjectContainer = (props: ContentSubjectContainerType) => {
  let sortedContentSubjects: ContentSubjectType[] = []
  if (props.contentSubjects) {
    sortedContentSubjects = props.contentSubjects.sort((a, b) => {
      const aIndex = ContentSubjectOrder.indexOf(a as any)
      const bIndex = ContentSubjectOrder.indexOf(b as any)
      return aIndex - bIndex
    })
  }

  return (
    <IconContainer>
      {sortedContentSubjects.map((contentSubject) => (
        <ContentSubjectIcon type={contentSubject} color={getContentSubjectColor(contentSubject)} />
      ))}
    </IconContainer>
  )
}

const LessonListItemTitle = ({
  title,
  contentSubject,
  contentSubjects,
}: Props) => {
  return (
    <TitleWrapper>
      <ContentSubjectContainer contentSubjects={contentSubject ? [contentSubject] : contentSubjects} />
      <Title>{title}</Title>
    </TitleWrapper>
  )
}

export default LessonListItemTitle
